












































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { app } from "../models/Application";
import { Order, OrderDetail, OrderStatus } from "../viewmodels/Order";
import { Product, ProductSize } from "../viewmodels/Product";
import { UserType } from "../services/LoginService";

@Component({})
export default class extends Vue {
  @Prop() private orderModel!: Order;

  public productCollection = app.productCollection;
  public staffCollection = app.staffCollection;

  public orderItemModel: OrderDetail = new OrderDetail();
  public productModel: Product = new Product({}, this.productCollection);
  public dialog = false;

  get promotions() {
    return this.productModel && this.productModel.promotions
      ? this.productModel.promotions
      : [];
  }

  get productSizes() {
    const sizes = [];
    if (this.productModel && this.productModel.price_regular) {
      sizes.push({ id: ProductSize.Regular, name: "Regular" });
    }
    if (this.productModel && this.productModel.price_medium) {
      sizes.push({ id: ProductSize.Medium, name: "Medium" });
    }
    if (this.productModel && this.productModel.price_large) {
      sizes.push({ id: ProductSize.Large, name: "Large" });
    }
    return sizes;
  }

  get orderType() {
    if (this.orderModel.takeout) {
      return "Takeout";
    } else if (this.orderModel.delivery) {
      return "Delivery";
    }
    return "In dining";
  }

  get orderStatuses() {
    if (this.orderModel.takeout) {
      return this.orderStatusesList.filter(x => x.id !== OrderStatus.Paid);
    } else if (this.orderModel.delivery) {
      return this.orderStatusesList.filter(x => x.id !== OrderStatus.Paid);
    }
    return this.orderStatusesList;
  }

  public orderItemsHeaders = [
    { text: "Product Id", value: "product_id" },
    { text: "Name", value: "product_name" },
    { text: "Quantity", value: "quantity" },
    { text: "Price", value: "product_price" },
    { text: "Size", value: "product_size" },
    { text: "Discount", value: "product_discount" },
    { text: "Comment", value: "comment" }
  ];

  public orderStatusesList = [
    {
      id: OrderStatus.ReadyForDelivery,
      name: "Ready for table/takeout/delivery"
    },
    {
      id: OrderStatus.Delivered,
      name: "Delivered to table / Picked up / Out to delivery"
    },
    { id: OrderStatus.Paid, name: "In dining paid by cash or credit card" }
  ];

  public orderStatus: any = null;

  @Watch("orderModel")
  public onOrderModelChange() {
    this.orderStatus = this.orderModel.status;
  }

  public get drivers() {
    return this.staffCollection.models
      .filter((x: any) => x.user_type === UserType.Driver)
      .map((e: any) => ({
        id: e.id,
        name: `${e.first_name} ${e.last_name}`
      }));
  }

  public close() {
    this.$emit("dialog-closed");
  }

  public closeItem() {
    this.dialog = false;
  }

  public async save() {
    try {
      const dialog: any = (this.$root as any).$confirm;
      dialog("Order Save", "This order will be saved?").then(
        async (confirm: boolean) => {
          if (confirm) {
            if (this.orderModel.delivery)
            {
              await this.orderModel.saveDriver(this.orderModel.driver_id);
            }
            if (this.orderModel.status !== this.orderStatus) {
              await this.orderModel.changeOrderStatus(this.orderStatus);
            }
            this.orderModel.status = this.orderStatus;
            this.$emit("dialog-closed");
            this.$store.dispatch("showSnackbar", {
              message: "Order saved succesfully!"
            });
          }
        }
      );
    } catch (e) {
      this.$store.dispatch("showSnackbar", {
        message: "Whoops, error while saving data!"
      });
    }
  }

  public async payByCash() {
    try {
      const dialog: any = (this.$root as any).$confirm;
      dialog("Payment", "This order will be paid by cash?").then(
        async (confirm: boolean) => {
          if (confirm) {
            await this.orderModel.payByCash(1);
            this.orderModel.status = OrderStatus.Paid;
            this.dialog = false;
            this.$store.dispatch("showSnackbar", {
              message: "Order paid succesfully!"
            });
          }
        }
      );
    } catch (e) {
      this.$store.dispatch("showSnackbar", {
        message: "Whoops, error while saving data!"
      });
    }
  }

  public async saveItem() {
    try {
      this.orderItemModel.product_id = this.productModel.id;
      await this.orderModel.saveOrderItem(this.orderItemModel);
      if (!this.orderItemModel.id) {
        this.orderModel.details.push(this.orderItemModel);
      }
      this.dialog = false;
      this.$store.dispatch("showSnackbar", { message: "Saved succesfully!" });
    } catch (e) {
      this.$store.dispatch("showSnackbar", {
        message: "Whoops, error while saving data!"
      });
    }
  }

  public removeItem(model: any) {
    const dialog: any = (this.$root as any).$confirm;

    dialog("Delete", "Are you sure?").then((confirm: boolean) => {
      if (confirm) {
        model.delete();
      }
    });
  }

  public addItem() {
    this.orderItemModel = new OrderDetail();
    this.dialog = true;
  }

  public async editItem(item: OrderDetail) {
    this.orderItemModel = item;
    this.productModel = await this.productCollection.findByID(item.product_id);
    this.dialog = true;
  }

  private getProductName(id: number) {
    const product = this.productCollection.find({
      id: id
    });
    if (product) {
      return product.name;
    }
    return "";
  }
}
